import { router } from '@inertiajs/vue3';

export const changeFilter = (url, callback, data) => {
    let toSend = {page: undefined};
    if (typeof data === 'object') {
        toSend = Object.assign({}, toSend, data)
    }
    router.visit(url,
        {
            only: ['products', 'filter'],
            preserveState: false,
            preserveScroll: true,
            data: toSend,
            onSuccess: (page) => {
                if (typeof callback === 'function') {
                    callback(page)
                }
            }
        }
    );
}
